<div class="content">
    <div>
        <div class="access-denied-message">
            Access denied<br>
            Please contact Admin for access
        </div>
    </div>
</div>
